import { render, staticRenderFns } from "./withholdChess.vue?vue&type=template&id=59ffc433&scoped=true"
import script from "./withholdChess.vue?vue&type=script&lang=ts"
export * from "./withholdChess.vue?vue&type=script&lang=ts"
import style0 from "./withholdChess.vue?vue&type=style&index=0&id=59ffc433&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ffc433",
  null
  
)

export default component.exports